import { Fragment, useEffect, useState } from 'react'
import { Switch, Route, useRouteMatch } from 'react-router-dom'
import { useHistory } from 'react-router'
import { useConfiguration } from 'appConfiguration/configurations'
import { PageContextProvider } from 'pageContext'
import config from 'config'
import { useAllCustomCategories } from 'hooks'
import SSOApplications from '.'
import { MyIdentityLayout } from 'components'
import SubHeader from 'components/SubHeader'

const SSOApplicationsRouter = () => {
    const history = useHistory()
    let { path } = useRouteMatch()
    const { dropDownOptions } = useConfiguration()
    const [openFilters, setOpenFilters] = useState(false)

    const currentOption = dropDownOptions.find((o) => o.route === path)
    const { data: customCategories } = useAllCustomCategories()

    useEffect(() => {
        const currentPath = window.location.pathname
        const currentCategoryId = currentPath.split('/').pop()
        const categoryStillExists = customCategories?.some(
            (category) => category.id === currentCategoryId,
        )
        if (categoryStillExists) return

        if (currentOption?.tabbedOptions?.length > 0) {
            history.push(
                `${currentOption.route}${currentOption.tabbedOptions[0].route}`,
            )
        } else {
            history.push(`${config.APP_SUBPATH}/forbidden`)
        }
    }, [customCategories])

    return (
        <Fragment>
            <MyIdentityLayout
                subHeader={
                    <SubHeader
                        showFilters={openFilters}
                        toggleFilters={() => setOpenFilters((prev) => !prev)}
                        showBackButton={false}
                        customTabs={customCategories}
                    />
                }
            >
                <Switch>
                    {currentOption?.tabbedOptions?.map((a) => (
                        <Route
                            key={a.name}
                            exact
                            path={currentOption?.route + a?.route}
                            render={() => (
                                <PageContextProvider>
                                    <SSOApplications isCustomTab={false} />
                                </PageContextProvider>
                            )}
                        />
                    ))}
                    {customCategories &&
                        customCategories?.map((a) => (
                            <Route
                                key={a.name}
                                exact
                                path={currentOption?.route + a?.route}
                                render={() => (
                                    <PageContextProvider>
                                        <SSOApplications isCustomTab={true} />
                                    </PageContextProvider>
                                )}
                            />
                        ))}
                </Switch>
            </MyIdentityLayout>
        </Fragment>
    )
}
export default SSOApplicationsRouter
